import React, { Component, Fragment } from 'react'
import Table from '@common/Table'
import columns from './column'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    return (
      <Fragment>
        <Table store={store} columns={columns(store)} />
      </Fragment>
    )
  }
}
